module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/v3/pc/common/icon_stethscope-35e849cc855261d9e1a17ca045d4d456.svg";